import { useState } from 'react';

import { useWorkspace } from '../../state/workspace.js';
import { MixerEditor } from './MixerEditor.js';
import { MIXER_EXT } from './mixer-doc.js';

/**
 * Shown over the Code tab's text editor while the active tab is a
 * `*.mixer.json`: the visual mixer editor, or (in text mode) a button back
 * to it.
 */
export function MixerOverlay() {
  const active = useWorkspace((s) => s.tabs.at(-1) ?? null);
  const [asText, setAsText] = useState<ReadonlySet<string>>(new Set());
  if (!active || !active.toLowerCase().endsWith(MIXER_EXT)) return null;
  const toggle = (text: boolean) =>
    setAsText((prev) => {
      const next = new Set(prev);
      if (text) next.add(active);
      else next.delete(active);
      return next;
    });
  if (asText.has(active)) {
    return (
      <button type="button" className="mixed-chip mixed-back" onClick={() => toggle(false)}>
        Mixer editor
      </button>
    );
  }
  return (
    <div className="mixed-overlay">
      <MixerEditor key={active} path={active} onShowText={() => toggle(true)} />
    </div>
  );
}
